<template>
  <div class="tooltip-wrapper">
    <div class="tooltip-icon" v-if="this.data.maxValueChart && this.data.maxValueChart.length">
      <span>{{ this.data.maxValueChart[0].value }}</span>
      <span v-if="this.data.maxValueChart.length > 1">{{ ',...' }}</span>
      <div ref="tooltipMaxValue" class="tooltip-container toolbar-scrollbar" :id="id">
        <div class="content-wrapper">
          <div class="tooltip-date">{{ data && data.date ? data.date : '' }}</div>
          <table class="tooltip-content">
            <tr v-for="(item, index) in dataChartMaxValue" :key="index">
              <td>
                <div class="tooltip-content_info">
                  <div class="tooltip-content_color" :style="{ backgroundColor: item.color }"></div>
                  <div class="tooltip-content_name ellipsis" v-lego-tooltip:ellipsis="item.name">
                    {{ item.name }}
                  </div>
                  <div class="tooltip-content_max_value">{{ item.pointFuntions }}</div>
                </div>
              </td>
              <td class="tooltip-content_value">{{ item.value }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TooltipChartMaxValue',
  props: {
    id: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {}
    },
    isThumbnail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataChartMaxValue: {}
    };
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler() {
        this.breakLabel();
      }
    }
  },
  methods: {
    getAnchorStyle() {
      this.$nextTick(() => {
        const tooltipWrapper = document.getElementById(this.id);

        if (tooltipWrapper) {
          const tooltipWrapperBottom = tooltipWrapper.getBoundingClientRect().bottom;
          const elementParentBottom = document
            .getElementsByClassName('formbox-col')[0]
            .getBoundingClientRect().bottom;
          const setTopPosition = elementParentBottom - tooltipWrapperBottom;
          if (setTopPosition < 0) {
            tooltipWrapper.style.top = `${setTopPosition}px`;
          }
        }
      });
    },
    breakLabel() {
      if (this.data.maxValueChart) {
        this.dataChartMaxValue = this.data.maxValueChart.map((item) => {
          const splitName = item.name.split('(');
          const maxValueChartItem = {
            color: item.color,
            name: splitName[0],
            pointFuntions: '(' + splitName[1],
            value: item.value
          };
          return maxValueChartItem;
        });
      }
    }
  },
  mounted() {
    if (this.isThumbnail) this.getAnchorStyle();
  }
};
</script>

<style lang="scss" scoped>
.tooltip-wrapper {
  .tooltip-icon {
    // cursor: pointer;
    position: relative;

    &:hover {
      .tooltip-container {
        visibility: visible;
      }
    }

    .tooltip-container {
      background-color: rgb(255, 255, 255);
      display: block;
      position: absolute;
      z-index: 1;
      border-radius: 4px;
      font-size: 12px;
      line-height: 16px;
      right: 22px;
      top: 3px;
      color: #2f3237;
      box-shadow: 0px 8px 15px 2px rgba(24, 25, 27, 0.15), 0px 0px 4px 0px rgba(24, 25, 27, 0.2),
        0px -1px 4px 0px rgba(24, 25, 27, 0.15);
      visibility: hidden;
      max-height: 280px;
      overflow-y: auto;

      .content-wrapper {
        padding: 8px;
      }

      .tooltip-date {
        width: max-content;
      }

      .tooltip-content {
        border-spacing: 0px;
        width: 100%;

        tr {
          td {
            padding-top: 4px;
          }
        }

        &_info {
          display: flex;
          align-items: center;
        }

        &_color {
          height: 10px;
          min-width: 10px;
          border-radius: 100%;
          margin-right: 4px;
        }

        &_name {
          max-width: 370px;
        }
        &_max_value {
          width: max-content;
          padding-right: 12px;
        }

        &_value {
          font-weight: 700;
          text-align: right;
        }
      }
    }
  }
}
</style>
